export default class ISiteEvent {
}
